/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_InspirationInputs */

const en_site_relation_inspiration = /** @type {(inputs: Site_Relation_InspirationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspiration`)
};

const id_site_relation_inspiration = /** @type {(inputs: Site_Relation_InspirationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspirasi`)
};

/**
* | output |
* | --- |
* | "Inspiration" |
*
* @param {Site_Relation_InspirationInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_inspiration = /** @type {((inputs?: Site_Relation_InspirationInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_InspirationInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_inspiration(inputs)
	return en_site_relation_inspiration(inputs)
});